import { Link } from "react-router-dom";
import { booklists, getComicsByIds } from "../../../mocks/manga";

export default function BooklistsSection() {
  const list = booklists.slice(0, 3);
  return (
    <section className="bg-background-100" aria-labelledby="home-booklist-heading">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 id="home-booklist-heading" className="font-display text-2xl text-foreground-950 md:text-3xl">
              精选书单
            </h2>
            <p className="mt-1 text-sm text-foreground-500">由资深读者整理的专题合集，一份书单解锁一片新天地</p>
          </div>
          <Link to="/booklists" className="flex items-center gap-1 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700">
            全部书单 <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {list.map((bl) => {
            const coverComics = getComicsByIds(bl.comicIds);
            return (
              <Link
                key={bl.id}
                to="/booklists"
                className="group overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 p-5 transition-transform hover:-translate-y-1"
              >
                <div className="flex gap-3">
                  <img src={bl.cover} alt={`${bl.name} 书单封面`} className="h-32 w-24 shrink-0 rounded-xl object-cover object-top" />
                  <div className="min-w-0 flex-1">
                    <span className="inline-flex rounded-md bg-accent-200 px-2 py-0.5 text-xs font-bold text-accent-900">#{bl.tag}</span>
                    <h3 className="mt-2 line-clamp-2 font-display text-lg leading-snug text-foreground-950 group-hover:text-primary-600">
                      {bl.name}
                    </h3>
                    <p className="mt-2 text-xs text-foreground-500">{bl.count} 部 · {bl.owner}</p>
                  </div>
                </div>
                <p className="mt-4 line-clamp-2 text-sm leading-relaxed text-foreground-600">{bl.desc}</p>
                <div className="mt-4 flex -space-x-2">
                  {coverComics.slice(0, 4).map((c) => (
                    <img key={c.id} src={c.cover} alt={c.title} className="h-10 w-7 rounded-md border-2 border-background-50 object-cover object-top" />
                  ))}
                  <span className="flex h-10 items-center rounded-md border-2 border-background-50 bg-background-100 px-2 text-xs text-foreground-500">
                    +{Math.max(bl.count - 4, 0)}
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}